/** GA4 Measurement ID for myked.com (public, baked into the client bundle). */
export const GA4_MEASUREMENT_ID = 'G-SYLBZMQ64C';
